import { render } from "./LegacyEdit.vue?vue&type=template&id=752d5c98"
import script from "./LegacyEdit.vue?vue&type=script&lang=js"
export * from "./LegacyEdit.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__